import { getClusteredItemIds, getEmptyState, getItemIds } from './items.tsx';
import { createSelectorHook } from './utils.tsx';

export const useItemIds = createSelectorHook(getItemIds);
export const useClusteredItemIds = createSelectorHook(getClusteredItemIds);
export const useEmptyState = createSelectorHook(getEmptyState);
